export default "__VITE_ASSET__DO_ef0KW__"